module.exports = __webpack_public_path__ + "assets/img/iarc-90181271.png";